import { AfterViewInit, Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { ConfigService } from '../../../services/config.service';
import { MtnApiService } from 'src/app/services/api/mtn/mtn.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-mtn-landing',
  templateUrl: './mtn-landing.component.html',
  styleUrls: ['./mtn-landing.component.scss'],
})
export class MtnLandingComponent implements OnInit, AfterViewInit, OnDestroy {

  readonly showConfirmationDialog = signal(false);

  constructor(
    private authService: AuthService,
    private configService: ConfigService,
    private router: Router,
    private mtnApiService: MtnApiService,
    private dialog: MatDialog
  ) {}

  ngOnDestroy(): void {
    document.querySelector<HTMLElement>('app-root').style.background = 'transparent';
  }

  ngAfterViewInit(): void {
    document.querySelector<HTMLElement>('app-root').style.background = 'black';
  }

  ngOnInit() {
    const whitelistClientList = [
      'P0001', // test-developer
      'E1133', // mtn
    ];

    if (this.authService.isAuthenticated() || !whitelistClientList.includes(this.configService.get().codCliente)) {
      this.router.navigate(['/']);
    }
  }

  onSave() {
    const form = document.querySelector('form');
    const dataForm = new FormData(form);
    const data: { type: string; value: string }[] = [
      {
        type: 'IDENTIFICADOR_EXTERNO',
        value: `10#_#${dataForm.get('email')}`,
      },
      {
        type: 'NOMBRE',
        value: `${dataForm.get('firstname')} ${dataForm.get('lastname')}`,
      },
      {
        type: 'CORREO_ELECTRONICO',
        value: String(dataForm.get('email')),
      },
      {
        type: 'CONTRASENNA',
        value: String(dataForm.get('password')),
      },
      {
        type: 'PAIS',
        value: String(dataForm.get('country')),
      },
      {
        type: 'SEXO',
        value: dataForm.get('gender') === 'Male' ? '1' : '2',
      },
      {
        type: 'CODIGO',
        value: 'BI136',
      },
    ];

    form.reportValidity();
    if (form.reportValidity()) {
      this.mtnApiService.createUserAccountMTN(data).subscribe((response) => {
        if (response) {
          this.showConfirmationDialog.set(true);
        }
      });
    }
  }

  scrollToContactForm() {
    const section = document.getElementById('contactForm');
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
